import React, { useEffect, useState,Suspense,lazy } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../index";
import styles from "./RaportForm.module.scss";
import { SignRaportFile, createRaport } from "service/StatementsService";
import { useDispatch, useSelector } from "react-redux";
import { postStatement } from "store/slices/StatementsSlice";
import Notification from "utils/Notifications";
import { TextareaAutosize } from "@mui/material";

import Dropdown from "../../../../Dropdown/Dropdown";
import userInfo from "utils/userInfo";
import { getMyMembers } from "service/CollectiveService";
import { setMyMembers } from "store/slices/CollectiveSlice";
import { ScaleLoader } from "react-spinners";
import { AddWaterMark } from "hooks/PdfWaterMark/AddWaterMark";
const OrderSigner = lazy(() => import('components/Forms/OrderForm/components/OrderSigner'))


function RaportForm({ setRender , setState}) {
  const { t } = useTranslation('common')
  const user = userInfo()
  const request_type = [
    { id: 0, label: t('forms.raportForm.doctype_business_plan') },
    { id: 1, label: t('forms.raportForm.doctype_thank_letter') },
    { id: 2, label: t('forms.raportForm.doctype_business_letter') },
    { id: 3, label: t('forms.raportForm.doctype_contract') },
    { id: 4, label: t('forms.raportForm.doctype_complaint') },
    { id: 5, label: t('forms.raportForm.doctype_info_request') },
    { id: 6, label: t('forms.raportForm.doctype_statement') },
    { id: 7, label: t('forms.raportForm.doctype_appeal') },
    { id: 8, label: t('forms.raportForm.doctype_project_passport') },
    { id: 9, label: t('forms.raportForm.doctype_letter') },
    { id: 10, label: t('forms.raportForm.doctype_order') },
    { id: 11, label: t('forms.raportForm.doctype_invitation') },
    { id: 12, label: t('forms.raportForm.doctype_report') },
    { id: 13, label: t('forms.raportForm.doctype_notification') },

  ]
  const [data] = useState()
  const [signer ,setSigner] = useState('')

 
  const [id, setId] = useState('');
  const [type_doc, setType_doc] = useState("");
  const [type, setType] = useState("");
  const [text, setText] = useState("");

  const [file, setFile] = useState([]);
  const [file1, setFile1] = useState(null);
  
  const [loader, setLoader] = useState(false);
  const [chooseFile,setChooseFile] = useState(false)
  const [chooseText,setChooseText] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const dispatch = useDispatch();


     const getData = async () => {
      try {
        let response = await getMyMembers('task',data);
        
        dispatch(
          setMyMembers({
            members: response.data,
          })
        );
    
      } catch (error) {
        
      }
      };
    
      useEffect(() => {
      getData();

      }, []);
    

    const myTeam = useSelector((state) => state.collective.members);
    const confirmedEmployees = myTeam ? [myTeam.confirmed] : []
    const dataRector = [confirmedEmployees.flat().filter((item) => item.flag)]
    const handleFileUpload = (e) => {
      const file = e.target.files[0];
      if (file.type === 'application/pdf') {
        setFile1(file);
      } else {

        setNotify({
          isOpen: true,
          message: t('forms.raportForm.select_pdf_file'),
          type: "warning",     sound: 'warning'
        });
      }
    };
    
    
  const onFileChange = (event) => {
    setFile(event.target.files);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    if (type === "") {
      setNotify({
        isOpen: true,
        message: t('forms.raportForm.no_subject'),
        type: "warning",     sound: 'warning'
      });

    }

    else if (file1 === null && text === ''){
      setNotify({
        isOpen: true,
        message: t('forms.raportForm.no_main_file_or_text'),
        type: "warning",     sound: 'warning'
      });

    }
    else if (type_doc === ''){
      setNotify({
        isOpen: true,
        message: t('forms.raportForm.no_doc_type'),
        type: "warning",     sound: 'warning'
      });

    }
    else if (signer === user.userId) {
      setNotify({
        isOpen: true,
        message: t('forms.raportForm.addressee_is_user'),
        type: "warning",     sound: 'warning'
      });
    }
    else if (file1 !== null && text !== '') {
      setNotify({
        isOpen: true,
        message: t('forms.raportForm.enter_content_or_file'),
        type: "warning",     sound: 'warning'
      });
    }
    else
    try {
  
  
  setLoader(true);
  const formData = new FormData();
  formData.append('addressee',signer);
  formData.append('type', type);
  formData.append('type_doc', type_doc);
  formData.append('text', text);
      if (file1) {
         formData.append('file', file1);
      }
 
  
  for (let i = 0; i < file.length; i++) {
    formData.append('files', file[i]);
  }
  
  
  
  
  
  let response = await createRaport(formData);

  dispatch(
    postStatement({
      addressee:signer,
         
            type:type,
            type_doc,
            text: text,
            file: file ? file.name : null,
          })
          );
          const modifedFile = await AddWaterMark({
            name: user.lastName ? `${user.surName}.${user.firstName?.split('')[0]}.${user.lastName?.split('')[0]}` : `${user.surName}.${user.firstName?.split('')[0]}`,

            type : "Подписал",
            count_turn : 1,
            file: response.data.file,
          });
          let SignStatementFile = {
            addressee: response.data.addressee,
            status: 'В режиме ожидания',
            file: modifedFile,
          };

          let response2 = await SignRaportFile(response.data.id, SignStatementFile);
        setNotify({
          isOpen: true,
          message: t('forms.raportForm.report_sent_success'),
           type: "success", sound : "success"
        });
        setState(({ isPaneOpen: false } ))
        setRender(true)

      } catch (error) {


        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
        });
      }finally {
        setLoader(false);
      }

  };


  return (
    <div>
         <div className={styles.signer} style={{width:'100%'}}>
       <Dropdown setId={setId} setType={setType_doc} title = {t('forms.raportForm.doc_type_title')} data = {request_type ?? []}/>
       </div>
      <div className={styles.signer}>
      <Suspense fallback={<p>Loading...</p>}>

<OrderSigner text = {t('forms.raportForm.to_label')} dataSigners = {dataRector[0]} setSigner = {setSigner}/>
</Suspense>
       </div>

       <TextareaAutosize
        id="type"
        name="type"
        className={styles.type_input}
        value={type}
        onChange={(e) => setType(e.target.value)}
        placeholder={t('forms.raportForm.subject_placeholder')}
        maxLength={255}

      />
        <div style={{display: 'flex', flexDirection: 'column' ,gap : '30px'}}>
      {
        chooseFile || chooseText ? null :  ( <div style={{display: 'flex', justifyContent: 'space-between'}}>

       <button onClick={() => setChooseFile(true)} style={{fontWeight: '400',padding: '3px 7px', borderRadius: '3px',border: 'none',cursor: 'pointer'}}><span style={{color: 'red', fontSize: '18px', fontWeight: '400'}}>*</span>{t('forms.raportForm.choose_main_document')}</button>
       <p>{t('forms.raportForm.or_word')}</p>
       <button  onClick={() => setChooseText(true)} style={{fontWeight: '400',padding: '3px 7px', borderRadius: '3px',border: 'none',cursor: 'pointer'}}><span style={{color: 'red', fontSize: '18px', fontWeight: '400'}}>*</span>{t('forms.raportForm.enter_document_content')}</button>
      </div>)
      }


      {chooseFile === true ? (<div className={styles.add_statement_file} style={{margin: '10px 0px'}}>
       <h4 style={{fontWeight: '400'}}><span style={{color: 'red', fontSize: '18px', fontWeight: '400'}}>*</span>{t('forms.raportForm.attach_main_document')}</h4>
       <input type="file" accept=".pdf" onChange={(e) => handleFileUpload(e)} />


      </div>) : null}
      {chooseText === true ? ( <TextareaAutosize
        id="text"
        name="text"
        type="textarea"
        className={styles.discription_input}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={t('forms.raportForm.content_placeholder')}

      />
      ) : null}


      <div style={{marginTop: '10px'}} className={styles.add_statement_file}>
       <h4 style={{fontWeight: '400'}}>{t('forms.raportForm.attach_additional_documents')}</h4>

      <input type="file" multiple  onChange={onFileChange} />
        <span>{t('forms.raportForm.file_attachment')}</span>
      </div>

      <div className={styles.statement_footer}>
      {loader ? (
        <ScaleLoader color="black" size={30} />
      ) : (
        <Button className={styles.btn1} onClick={handleSubmit}>
          {t('common.submit')}
        </Button>
      )}
      
      </div>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
    
  );
}

export default RaportForm;
